export enum eUserType{
    ADMIN = 1,
    SHIPPER,
    CARRIER,
    DRIVER,
    OWNER_OPERATOR,
    BRANCH_ADMIN,
    FINANCIAL_ADMIN,
    STAFF,
    CARRIER_FINANCIAL_ADMIN,
    CARRIER_BRANCH_ADMIN,
    DISPATCHERS
  }
export enum LeaveRequestStatus {
  PENDING = 1,
  APPROVED = 2,
  CANCELLED = 3
}

export enum CarrierDriverStatus {
  ACTIVE = 1,
  INACTIVE = 2,
}
export enum ChatRoomType {
  PRIVATE = 1,
  GROUP = 2
}
export enum ChatMessageType {
  TEXT = 1,
  IMAGE = 2,
  FILE = 3
}

export enum carrierStaffType{
    CARRIER_FINANCIAL_ADMIN = 5,
    CARRIER_BRANCH_ADMIN = 4,
    DISPATCHERS = 11
  }

export const MaskTypes = {
    // phoneMask: [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    // zipcodeMask: [/[0-9]/, /\d/, /\d/, /\d/, /\d/],
    // phonecodeMask: [/[1-9]/, /\d/, /\d/, /\d/],
    // otpMask: [/[1-9]/, '-', /\d/, '-', /\d/, '-', /\d/, '-', /\d/],
    // meridiemTime: [/\d/, /\d/, ':', /\d/, /\d/],
    phoneMask: '(000)000-0000',
    zipcodeMask: '00000',
    phonecodeMask: '0000',
    otpMask: '0-0-0-0',
    meridiemTime: '00:00',
};

